import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { FormControl, Select, Input, MenuItem, InputLabel, TextField } from '@material-ui/core';
import { CustomSingleSelectDropDownStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import Autocomplete from '@material-ui/lab/Autocomplete';

export class MultiSelectDropDown extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onAutoCompleteChange(val) {
    this.setState({
      value: val
    })
    this.props.onChange(val)
  }

  render() {
    const fieldParams = {
      fullWidth: true,
      multiple: this.props.multiSelect || false,
      options: this.props.options,
      value: this.state.value || ''
    };
    console.log('this.props.options', this.props.options)
    return (
      <div className={css(Styles.container, this.props.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)}>
          <div className={css(Styles.innerContainer)}>
            <form autoComplete='off'>
              <FormControl className={css(Styles.formControlMain)} fullWidth  >
                {this.props.labe && <p className={css(Styles.label)}>{this.props.label}</p>}
                <Autocomplete
                  {...fieldParams}
                  onChange={(e, val) => this.onAutoCompleteChange(val)}
                  getOptionLabel={(option) => option.label || option.text}
                  renderOption={(option) => (
                    <div>{option.text || option.label}</div>
                  )}
                  classes={{
                    tag: css(Styles.tag),
                    popupIndicator: css(Styles.popupIndicator),
                    popper: css(Styles.dialog)
                  }}
                  renderInput={params =>
                    <TextField
                      {...params}
                      variant={'standard'}
                      placeholder={this.props.placeHolder || ''}
                      className={css(Styles.formControl)}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        classes: {
                          root: css(Styles.textInputStyles),
                          input: css(Styles.formInputStyle, Styles.textInput),
                        },
                      }} />}
                />
              </FormControl>
            </form>
          </div>
        </form>
      </div>
    )
  }

}

const Styles = StyleSheet.create({
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    }
  },
  leftGridPadding: {
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  rightGridPadding: {
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  errorMsg: {
    paddingRight: 20,
    color: '#f44336'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  marginLeft: {
    color: 'white'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30
  },
  pendingApprovalLabel: {
    marginTop: 0,
    marginBottom: 0,
    color: 'orange',
    fontSize: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: 'black',
    fontSize: 10,
    cursor: 'pointer',
  },
  uploadFieldLabel: {
    marginTop: 10,
  },
  buttonDelete: {
    background: '#FF0D0D'
  },
  label: {
    fontSize: 14,
    color: '#121212',
    margin: 0,
    marginBottom: 8,
    fontWeight: '467'
  },
  formControl: {
    borderRadius: 8,
    border: 'none',
    background: '#F7F7F9',
    overflow: 'hidden'
  },
  textInput: {
    padding: '4px 0px',
    maxWidth: 175
  },
  textInputStyles: {
    padding: '9.5px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    backgroundColor: '#ffffff',
    minWidth: 250
  },
  textInputStylesDisabled: {
    backgroundColor: '#d9d9d9',
  },
  pickerStyle: {
    marginTop: 0
  },
  pickerInputStyles: {
    padding: '8px 20px !important',
    flex: '1 1 0% !important',
    textAlign: 'left !important',
    color: 'rgb(34, 34, 34) !important',
    fontSize: '16px !important',
    borderRadius: '8px !important',
    overflow: 'hidden !important',
    background: '#f7f7f9'
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    },
    fontSize: 14
  },
  tag: {
    backgroundColor: '#e0e0e0',
    color: '#222222',
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  popupIndicator: {
    marginRight: 5,
  },
  dialog: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
  },

  modalCloseIcon: {
    width: 12,
    height: 12,
    padding: 1,
    borderRadius: 6
  },

  fieldOuterContainer: {
    display: 'flex'
  },
  fieldLeftInnerContainer: {
    flex: 1,
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  fieldRightInnerContainer: {
    flex: 1,
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  delFieldContainer: {
    width: '25%',
    marginRight: 20
  },
  formControlMain: {
    marginTop: 0,
    marginBottom: 0
  },
  optionImageContainer: {
    width: 20,
    height: 20,
  },
  optionImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  optionImageContainerSpec: {
    marginRight: 9,
    marginLeft: 5
  },
  textFieldHelperText: {
    color: '#000000',
    fontSize: 14,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 10,
    bottom: 0
  },
  charCounter: {
    margin: 0
  },
  deleteInputStyle: {
    height: 8
  },
  optionLoaderSpinner: {
    marginRight: 15
  },
  addOptionStyle: {
    color: AppTheme.buttonBg
  }
})



// WEBPACK FOOTER //
// ./src/common/components/MultiSelectDropDown.js